// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__uaD72","title":"ClientCherryInfo_title__5cs4m","itemText":"ClientCherryInfo_itemText__bqq8w"};